import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Bot, Headset, LogIn } from 'lucide-react';

interface HeaderProps {
  onContactClick: (e: React.MouseEvent) => void;
  onAuthClick: () => void;
  onDemoClick: () => void;
}

export function Header({ onContactClick, onAuthClick, onDemoClick }: HeaderProps) {
  return (
    <header className="bg-black/80 backdrop-blur-sm sticky top-0 z-50 border-b border-zinc-800">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <div className="relative w-10 h-10 bg-zinc-900 rounded-full flex items-center justify-center">
            <Bot className="w-6 h-6 text-emerald-400 absolute" />
            <Headset className="w-8 h-8 text-emerald-500/70 absolute" />
          </div>
          <span className="font-bold text-xl text-white">RestroCalls.AI</span>
        </Link>
        <div className="hidden md:flex space-x-8">
          <HashLink smooth to="/#services" className="text-zinc-300 hover:text-emerald-400 transition">Services</HashLink>
          <HashLink smooth to="/#pricing" className="text-zinc-300 hover:text-emerald-400 transition">Pricing</HashLink>
          <HashLink smooth to="/#features" className="text-zinc-300 hover:text-emerald-400 transition">Features</HashLink>
          <Link to="/about" className="text-zinc-300 hover:text-emerald-400 transition">About</Link>
          <Link to="/blog" className="text-zinc-300 hover:text-emerald-400 transition">Blog</Link>
          <a href="#contact" onClick={onContactClick} className="text-zinc-300 hover:text-emerald-400 transition">Contact Us</a>
        </div>
        <div className="flex items-center space-x-4">
          <a
            href="https://restroplay.restrocalls.ai/auth"
            className="flex items-center space-x-2 text-zinc-300 hover:text-emerald-400 transition"
          >
            <LogIn className="w-4 h-4" />
            <span>Sign In</span>
          </a>
          <button 
            onClick={onDemoClick}
            className="bg-emerald-500 text-black px-6 py-2 rounded-full hover:bg-emerald-400 transition shadow-sm hover:shadow-emerald-500/20"
          >
            Schedule Demo
          </button>
        </div>
      </nav>
    </header>
  );
}